import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";

export const CtaLink = ({ to = "/contact", id, variant = "gold", children, className = "", arrow = true }) => (
  <Link to={to} data-cta={id} data-testid={`cta-${id}`} className={`btn-${variant} ${className}`}>
    {children}
    {arrow && <ArrowRight aria-hidden="true" className="h-4 w-4" />}
  </Link>
);

export const ExtLink = ({ href, children, className = "text-link", testId, ...rest }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 ${className}`} data-testid={testId} {...rest}>
    {children}
    <ArrowUpRight aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />
    <span className="sr-only"> (opens in a new tab)</span>
  </a>
);

export const SectionHead = ({ eyebrow, title, as: H = "h2", id, children, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
    <H id={id} className={H === "h1" ? "text-4xl font-bold sm:text-5xl lg:text-6xl" : "h2"}>{title}</H>
    {children && <div className="lede mt-6 space-y-4">{children}</div>}
  </div>
);

export const PageHero = ({ eyebrow, title, children }) => (
  <section className="on-dark border-b border-gold/30 bg-ink text-ivory">
    <div className="wrap py-16 md:py-24">
      <SectionHead eyebrow={eyebrow} title={<span className="text-ivory">{title}</span>} as="h1">{children}</SectionHead>
    </div>
  </section>
);
